import { parseRoute } from './router'

export type ClientMountMode = 'hydrate' | 'render'

/**
 * Eldonti, hogy a #root-ban levo HTML ugyanahhoz a laphoz tartozik-e,
 * amelyet a kliens most meg akar jeleniteni.
 *
 * Csak a fooldal kap tenylegesen elorenderelt React-fát. Egy dinamikus
 * aloldal (peldaul `/admin` vagy `/ajanlat/...`) az nginx SPA fallbackje
 * miatt megkaphatja ugyanezt az `index.html`-t. A puszta `hasChildNodes()`
 * ilyenkor felrevezeto: ha arra hidrataljuk az aloldalt, a regi fooldal a
 * DOM-ban maradhat, az uj lap pedig ala kerul.
 *
 * Aloldalon ezert elobb kiuritjuk a gyokeret. A fuggveny szandekosan a
 * torlest is elvegzi, hogy a hivo ne tudjon veletlenul egy nem ures
 * konteneren `createRoot()`-ot inditani.
 */
export function kliensMountMod(root: HTMLElement, pathname: string): ClientMountMode {
  const route = parseRoute(pathname)

  if (route.name === 'home' && root.hasChildNodes()) return 'hydrate'

  root.replaceChildren()
  return 'render'
}
